$shm_hitalama_map_widget_entity_form_view $mol_form
	map $shm_hitalama_map
	form $shm_hitalama_map_widget_entity_form
	session_id? \0
	form_fields /
		<= Query_field $mol_form_field
			name \Поисковой запрос
			bid <= query_bid \
			Content <= Query $mol_string
				value? <=> query? \
		<= Excluded_words_field $mol_form_field
			name \Минус-слова
			Content <= Excluded_words $mol_textarea
				value? <=> excluded_words? \
		<= Period_field $mol_form_field
			name \Период
			content /
				<= Period $shm_period
					date_from? <=> date_from? \
					date_to? <=> date_to? \
		<= Country_field $mol_form_field
			name \Страны
			Content <= Country $mol_string
				value? <=> country? \
		<= Language_field $mol_form_field
			name \Языки
			Content <= Language $mol_string
				value? <=> language? \
		^ social_media_field / <= Social_media_field*0 $mol_form_field
			name \Соц.медиа
			bid <= file_bid \
			content <= content_social_media* /
				<= Social_media_file* $mol_attach
					attach_new? <=> social_media_attach*? null
				<= Social_media_name $mol_paragraph
					title <= social_media_title \
		^ mass_media_field / <= Mass_media_field*0 $mol_form_field
			name \СМИ
			bid <= file_bid \
			content <= content_mass_media* /
				<= Mass_media_file* $mol_attach
					attach_new? <=> mass_media_attach*? null
				<= Mass_media_name $mol_paragraph
					title <= mass_media_title \
		<= Type_field $mol_form_field
			name \Type
			Content <= Type $mol_search
				hint \Выбрать...
				query? <=> type? \
				suggests_showed? => type_suggests_showed?
				focused? => type_focused?
				suggest_select*? <=> type_select*? null
				suggests /
					\инфоповод
					\компания
					\персона
					\событие
					\процесс
					\география
		<= Tags_field $mol_form_field
			name \Tags
			Content <= Tags $mol_string
				value? <=> tags? \
		<= Category_field $mol_form_field
			name \Category
			Content <= Category $mol_string
				value? <=> category? \
	body <= form_body /
		<= Query_group $mol_form_group sub /
			<= Query_field
			<= Excluded_words_field
		<= Period_field
		<= Group $mol_form_group sub /
			<= Country_field
			<= Language_field
		<= Files $mol_form_group sub /
			^ social_media_field
			^ mass_media_field
		<= Tags_group $mol_form_group sub /
			<= Type_field
			<= Tags_field
			<= Category_field
	buttons /
		<= Publish $mol_button_major
			title \Отправить
			click? <=> submit? null
			enabled <= submit_allowed
		<= Result $mol_status
			message <= result? \
		<= Clear $mol_button_minor
			title \Очистить
			click? <=> clear? null
			- enabled <= changed false
